var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-screen"},[_c('div',{staticClass:"container-fluid-sm"},[_c('video-player',{staticClass:"video-player-box"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }